import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-828477e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "counter-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Счётчик аудитории", -1))
const _hoisted_3 = { class: "count" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

import { ref, watch } from "vue";
import { formatNumber } from "@/services/utils/Strings";


export default /*#__PURE__*/_defineComponent({
  __name: 'AudienceCounter',
  props: {
    settedCount: {}
  },
  emits: ["updateAudienceCount"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const countAudience = ref<number | null | undefined>(props.settedCount);

watch(
  () => props.settedCount,
  (newValue) => {
    countAudience.value = newValue;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (countAudience.value !== null && countAudience.value !== undefined)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(formatNumber)(countAudience.value)), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_5, "—"))
    ])
  ]))
}
}

})